import { DeviceType } from "@/types/device.type";
import { PotooLandingContentsType } from "@/types/language";
import { useEnvironment } from "@/hooks/useEnvironment";

const { CREDIT_PER_SKU } = useEnvironment();
export const koreanContents: PotooLandingContentsType = {
  header: {
    navItems: ["서비스 소개", "가격 안내", "고객 사례", "회사 소개"],
    trailButtonLabel: "무료로 시작하기",
    aboutUsURL: "https://codimecareer.oopy.io/",
  },
  heroSection: {
    headlines: {
      [DeviceType.PC]: ["피팅 모델 사진 이제 10분이면 OK!"],
      [DeviceType.MO]: ["피팅 모델 사진", "이제 10분이면 OK!"],
    },
    subtitle: {
      [DeviceType.PC]: ["쉽고 빠른 패션 모델컷 생성 AI 솔루션"],
      [DeviceType.MO]: ["쉽고 빠른 패션 모델컷", "생성 AI 솔루션"],
    },
    signUpButtonLabel: "지금 무료로 시작하기",
  },
  socialProofSection: {
    texts: {
      [DeviceType.PC]: [
        "다른 색상을 직접 촬영하지 않아도 자동으로 생성되는게 편리했고,<br/>모델이 기대보다 예뻐서 놀랐어요!",
        "포투가 재질도 잘 표현해주어서 놀랐어요.<br/>생각보다 디테일하게 결과가 잘 생성되었어요.",
        "모델 컷 촬영은 너무 많은 시간과 돈이 들어가고,<br/>촬영 대행도 마음에 안 드는 경우가 많았는데,<br/>너무 간편하게 새로운 모델 컷을 생성할 수 있어 편했어요.",
        "다양한 코디 콘텐츠를 클릭만으로<br/>무제한 생성할 수 있다니 정말 놀라워요!<br/>확실히 구매 전환율을 올릴 수 있을 것 같아요.",
        "포투는 베타 출시 전부터,<br/>가장 크게 관심 갖고 있던 모델 컷 생성 솔루션이었어요.<br/>빠르게 다양한 사진을 생성할 수 있는게 가장 큰 장점이에요!",
        "촬영에 드는 시간, 인원 등<br/>많은 리소스를 절감할 수 있어서 좋았어요.",
      ],
      [DeviceType.MO]: [
        "다른 색상을 직접 촬영하지 않아도 자동으로 생성되는게 편리했고,<br/>모델이 기대보다 예뻐서 놀랐어요!",
        "포투가 재질도 잘 표현해주어서 놀랐어요. 생각보다 디테일하게 결과가 잘 생성되었어요.",
        "모델 컷 촬영은 너무 많은 시간과 돈이 들어가고, 촬영 대행도 마음에 안 드는 경우가 많았는데, 너무 간편하게 새로운 모델 컷을 생성할 수 있어 편했어요.",
        "다양한 코디 콘텐츠를 클릭만으로 무제한 생성할 수 있다니 정말 놀라워요! 확실히 구매 전환율을 올릴 수 있을 것 같아요.",
        "포투는 베타 출시 전부터,<br/>가장 크게 관심 갖고 있던 모델 컷 생성 솔루션이었어요. 빠르게 다양한 모델 컷을 생성할 수 있는게 가장 큰 장점이에요!",
        "촬영에 드는 시간, 인원 등<br/>많은 리소스를 절감할 수 있어서 좋았어요.",
      ],
    },
    names: [
      "패션 브랜드 Jeorney",
      "패션 쇼핑몰 Mazel Brown",
      "패션 쇼핑몰 Shushu j",
      "패션 플랫폼 비크",
      "패션 쇼핑몰 옷자락",
      "패션 쇼핑몰 HWASE",
    ],
  },
  benefitsSectionMain: {
    headline: "패션 이커머스 모델 컷, 아직",
    carouselTexts: [
      "촬영",
      "모델 섭외",
      "로케이션 섭외",
      "촬영 외주 컨택",
      "수많은 견적 비교",
      "도매 사진 활용",
    ],
    headlineSuffix: "하고 계세요?",
    highlighted: {
      [DeviceType.PC]: "포투에서는 업로드 ✦ 클릭 ✦ 다운로드 끝!",
      [DeviceType.MO]: "포투에서는 업로드 ✦ 클릭 ✦ 다운로드 끝!",
    },
  },
  benefitsSectionSub1: {
    title: {
      [DeviceType.PC]: ["진짜 같은 AI 모델 컷"],
      [DeviceType.MO]: ["진짜 같은 AI 모델 컷"],
    },
    subtitle: {
      [DeviceType.PC]: ["아래 이미지는 후보정을 전혀 거치지 않은 포투의 AI 모델컷입니다"],
      [DeviceType.MO]: ["아래 이미지는 후보정을 전혀 거치지 않은 포투의 AI 모델컷입니다"],
    },
  },
  benefitsSectionSub2: {
    headlines: {
      [DeviceType.PC]: ["리소스는 줄이고,", "매출은 올리고"],
      [DeviceType.MO]: ["리소스는 줄이고, 매출은 올리고"],
    },
    subtitle: {
      [DeviceType.PC]: ["실제 매출로 이어지는 매력적인 모델 컷", " (D사 실제 사례)"],
      [DeviceType.MO]: ["실제 매출로 이어지는 매력적인 모델 컷", " (D사 실제 사례)"],
    },
    benefitTextList: [
      [
        { title: "트래픽 증가", description: "48%" },
        { title: "구매 전환율 증대", description: "8%" },
        { title: "판매량 증가", description: "60%" },
      ],
    ],
    graphLabel1: "포투 적용 전 : 스튜디오 모델 컷 사용",
    graphLabel2: "포투 적용 후 : AI 모델 컷 사용",
    graphData1: "트래픽",
    graphData2: "구매 전환율",
    graphData3: "판매량",
    buttonText: "지금 무료로 시작하기",
  },
  featureSection1: {
    tabTextList: ["50 여종 이상의 배경 선택", "전속 AI 모델", "뒷면 모델컷 생성"],
    headlines: {
      [DeviceType.PC]: ["스튜디오·야외 촬영/모델 구인? 이제 포투AI로 한 방에 쉽게!"],
      [DeviceType.MO]: ["스튜디오·야외 촬영/모델 구인? 이제 포투AI로 한 방에 쉽게!"],
    },
    subtitles: {
      [DeviceType.PC]: ["모델 섭외, 스튜디오 촬영 없이 바로 상품을 판매해 보세요!"],
      [DeviceType.MO]: ["모델 섭외, 스튜디오 촬영 없이 바로 상품을 판매해 보세요!"],
    },
  },
  featureSection2: {
    headlines: {
      [DeviceType.PC]: ["상품 컷 단 1장으로 매력적인 모델의 착용 컷 생성"],
      [DeviceType.MO]: ["상품 컷 단 1장으로 매력적인 모델의 착용 컷 생성"],
    },
    contentsTitle: "착용 모델 컷 생성",
    subtitles: [
      "상품 컷만으로는 고객에게 어필하기 부족해요.",
      "<br/>",
      '포투를 통해 <span className="violet-500">구매 전환율을 2배 이상</span> 높여보세요',
    ],
    creditInfo: "1 크레딧 = 1400원",
  },
  featureSection3: {
    headlines: {
      [DeviceType.PC]: ["패션 이커머스에", "<br/>", "필요한 콘텐츠를 한 곳에서!"],
      [DeviceType.MO]: ["패션 이커머스에", "<br/>", "필요한 콘텐츠를", "<br/>", "한 곳에서!"],
    },
    contentsTitle: "올인원 콘텐츠 솔루션",
    label: "출시 예정",
    subtitles: {
      [DeviceType.PC]: [
        "상세 페이지, 상품 설명, 숏폼 콘텐츠,",
        "<br/>",
        '<span className="green-600">판매부터 마케팅까지</span> 필요한 사진을 생성하고',
        "<br/>",
        "자동으로 업로드해 보세요.",
      ],
      [DeviceType.MO]: [
        "상세 페이지, 상품 설명, 숏폼 콘텐츠,",
        "<br/>",
        '<span className="green-600">판매부터 마케팅까지</span> 필요한 사진을 생성하고',
        "<br/>",
        "자동으로 업로드해 보세요.",
      ],
    },
  },
  ctaSection: {
    title: "세상에서 가장 쉬운 패션 AI 솔루션",
    subtitle: "포투의 혁신을 경험해 보세요",
    signUpButtonText: "지금 무료 체험하기",
  },
  rollingBannerSection: {
    title: "840개 이상의 패션 브랜드가 믿고 이용하는 Potoo",
    contactUsButton: "지금 무료로 시작하기",
  },
  faqSection: {
    title: "자주 묻는 질문",
  },
  customerSection: {
    headline: {
      title: "고객 사례",
      subtitle: {
        [DeviceType.PC]: "비즈니스에 실질적 변화를 더한 성장 경험, 고객의 목소리로 확인해 보세요.",
        [DeviceType.MO]: (
          <>
            비즈니스에 실질적 변화를 더한 성장 경험,
            <br />
            고객의 목소리로 확인해 보세요.
          </>
        ),
      },
    },
    cta: {
      title: "Potoo AI가 비즈니스에 어떤 변화를 가져올지 확인해 보세요!",
      buttonText: "포투 도입 문의",
    },
  },
  customerStorySection: {
    cta: {
      title: (
        <>
          Potoo의 AI 솔루션이
          <br />
          어떻게 효과를 발휘했는지 궁금하신가요?
        </>
      ),
      buttonText: "포투 도입 문의",
    },
    bottomButton: {
      likedButtonText: "좋아요",
      shareToastText: "링크 복사가 완료됐어요. 공유해 보세요!",
    },
    relatedStory: {
      title: "함께 읽으면 좋은 글",
    },
  },
  creditSection: {
    title: "합리적인 가격으로 고퀄리티 모델 컷 촬영",
    subtitle: "필요한 만큼 크레딧을 충전하고, 모델 컷을 효율적으로 촬영해 보세요.",
    contactUsButton: "문의하기",
    freeTrialButton: "무료 크레딧 받기",
    faqTitle: "자주 묻는 질문",
    ctaTitle: "지금 회원가입하고 ",
    ctaSubtitle: "포투 AI를 무료 체험해 보세요.",
    ctaButton: "지금 무료 체험하기",
    creditGuideTitle: "1 크레딧 = 1400원",
  },
  creditPriceGuide: { 
    singleOutfit: "단일 제품컷",
    multipleOutfit: "착장 제품컷",
    modelCut: "모델컷 10장",
    credits: "크레딧",
    subTextSingleOutfit: ": 단일 제품",
    subTextMultipleOutfit: ": 착장 제품",
  },
  creditRecharge: {
    title: "Credits Recharge",
    description: "쉽고 빠르게 크레딧을 충전해 보세요.",
    creditInfo: {
      pricePerCredit: "1 크레딧 = 1400원",
      productCredit: {
        text: `상품 1개 : 모델 컷 무제한 생성 = ${CREDIT_PER_SKU} 크레딧`,
        coloredText: "모델 컷 무제한 생성",
      },
      watermarkInfo: "한 번만 결제하면 워터마크는 영구적으로 사라져요.",
      //colorCredit: "다른 색상 추가 1개당 = 8 크레딧",
    },
    creditCard: {
      modelCutProduct: "모델 컷 생성 가능 상품",
      unit: "개",
      //singleColor: "(단일 색상 기준)",
      currency: "원",
      creditText: "크레딧",
      recommendedCredit: "권장 크레딧",
      bonus: "보너스",
      enterprise: {
        title: "Enterprise",
        description: "기업 고객 맞춤 서비스 제공",
        cost: "이용 가격 협의",
      },
    },
    creditGuide: {
      title: "크레딧 이용 안내",
      freeCredit: {
        title: "최초 무료 크레딧 지급",
        description:
          "회원 가입 시 최초 1회만 무료 크레딧이 제공되며, 이후에는 추가 지급되지 않아요.",
      },
      validity: {
        title: "크레딧 유효 기간",
        description:
          "구매한 모든 크레딧(유료 및 보너스)은 구매일로부터 24개월 동안 사용할 수 있어요.",
      },
      expirationNotice: {
        title: "크레딧 소멸 기한 전 알림",
        description:
          "크레딧 소멸 기한 30일, 7일 전에 메일, 문자 메시지 등 알림을 통해 안내드릴게요.",
      },
      refundPolicy: {
        title: "크레딧 환불 정책",
        refundable:
          "구매한 크레딧은 언제든 환불이 가능하며, 사용한 유료 크레딧을 제외한 금액이 환불됩니다.",
        within7Days:
          "구매 후 7일 이내에 크레딧을 사용하지 않았다면, 환불 요청 시 전액을 환불해 드려요.",
        after7Days:
          "구매 후 7일이 지난 경우, 사용한 크레딧 금액과 10%의 환불 수수료를 제외한 금액을 환불합니다.",
        refundMethod: "환불은 결제 시 사용한 수단으로 처리됩니다.",
      },
      deductionOrder: {
        title: "크레딧 차감 순서",
        description:
          "보유한 크레딧은 유료 크레딧부터 차감되며, 이후 유효 기간에 따라 보너스 크레딧이 차감됩니다.",
        example: {
          title: "예시:",
          paid1: "유효 기간: 2026년 1월 30일까지의 유료 크레딧",
          bonus1: "유효 기간: 2026년 1월 30일까지의 보너스 크레딧",
          paid2: "유효 기간: 2026년 3월 30일까지의 유료 크레딧",
          bonus2: "유효 기간: 2026년 3월 30일까지의 보너스 크레딧",
          order: "소멸 순서: 1 → 2 → 3 → 4",
        },
      },
      priceChange: {
        title: "크레딧 가격 변동",
        description: "크레딧 가격은 언제든 변동될 수 있어요.",
      },
      bonusRefund: {
        title: "보너스 크레딧 환불",
        description: "보너스 크레딧은 환불되지 않아요.",
      },
    },
    askCount: "생성하려는 상품의 개수를 알려주세요.",
    rechargeButton: "즉시 구매",
    enterpriseButton: "도입 문의",
  },
  Banner: {
    pcTitle:
      "🎉 첫 가입 혜택! <span style='font-weight: 700'>30크레딧 받고,</span> 7개 상품의 모델 컷을 제작해 보세요. 🎉",
    mobileTitle: "🎉 첫 가입 혜택! <span style='font-weight: 700'>30크레딧 무료</span> 🎉",
    radioLabel: "7일간 보지 않기",
  },
};

export const englishContents: PotooLandingContentsType = {
  header: {
    navItems: ["Product", "Pricing", "Customer Stories", "About us"],
    trailButtonLabel: "Free Trial",
    aboutUsURL: "http://youtube.com/watch?si=UidaDXEaXOcEFY05&v=TLqXmJXb6_8&feature=youtu.be",
  },
  heroSection: {
    headlines: {
      [DeviceType.PC]: ["Get On-Model Images in Just 10 Minutes!"],
      [DeviceType.MO]: ["Get On-Model Images in Just 10 Minutes!"]
    },
    subtitle: {
      [DeviceType.PC]: ["The easy & fast AI solution for fashion model images."],
      [DeviceType.MO]: ["The easy & fast AI solution for fashion model images."]
    },
    signUpButtonLabel: "Start for Free Now",
  },
  socialProofSection: {
    texts: {
      [DeviceType.PC]: [
        "It was convenient to automatically generate different color variations without needing to shoot them directly, and I was pleasantly surprised by how beautiful the model was!",
        "I was amazed at how well Potoo captured the texture. The result was much more detailed than I expected.",
        "Shooting model cuts takes too much time and money, and I was often dissatisfied with outsourcing the photoshoots. But with Potoo, it was so convenient to easily generate new model cuts.",
        "It's amazing that I can generate unlimited styling content with just a click! I’m sure this will significantly boost the conversion rate.",
        "Even before its beta launch, Potoo was the model cut generation solution I was most interested in. The biggest advantage is the ability to quickly generate a variety of model cuts!",
        "I loved that we could save so many resources, such as time and personnel needed for photoshoots.",
      ],
      [DeviceType.MO]: [
        "It was convenient to automatically generate different color variations without needing to shoot them directly, and I was pleasantly surprised by how beautiful the model was!",
        "I was amazed at how well Potoo captured the texture. The result was much more detailed than I expected.",
        "Shooting model cuts takes too much time and money, and I was often dissatisfied with outsourcing the photoshoots. But with Potoo, it was so convenient to easily generate new model cuts.",
        "It's amazing that I can generate unlimited styling content with just a click! I’m sure this will significantly boost the conversion rate.",
        "Even before its beta launch, Potoo was the model cut generation solution I was most interested in. The biggest advantage is the ability to quickly generate a variety of model cuts!",
        "I loved that we could save so many resources, such as time and personnel needed for photoshoots.",
      ],
    },
    names: [
      "Fashion Brand Jeorney",
      "Fashion Shopping Mall Mazel Brown",
      "Fashion Shopping Mall Shushu j",
      "Fashion Platform Beekk",
      "Fashion Shopping Mall Osjarak",
      "Fashion Shopping Mall HWASE",
    ],
  },
  benefitsSectionMain: {
    headline: "Fashion model shooting, Still",
    carouselTexts: [
      "Doing by yourself",
      "Hiring models",
      "Booking locations",
      "Contacting agencies",
      "Comparing sheets",
      "Giving up",
    ],
    headlineSuffix: "?",
    highlighted: {
      [DeviceType.PC]: "In Potoo, it’s as simple as" + "<br/>" + "Upload ✦ Click ✦ Download",
      [DeviceType.MO]: "In Potoo, it’s as simple as" + "<br/>" + "Upload ✦ Click ✦ Download",
    },
  },
  benefitsSectionSub1: {
    title: {
      [DeviceType.PC]: ["AI Model Images That Look Truly Real"],
      [DeviceType.MO]: ["AI Model Images That Look Truly Real"],
    },
    subtitle: {
      [DeviceType.PC]: ["The images below were generated by Potoo with no retouching or manual editing."],
      [DeviceType.MO]: ["The images below were generated by Potoo with no retouching or manual editing."],
    },
  },
  benefitsSectionSub2: {
    headlines: {
      [DeviceType.PC]: ["Reduce Resources, Boost Sales"],
      [DeviceType.MO]: ["Reduce Resources, Boost Sales"],
    },
    subtitle: {
      [DeviceType.PC]: ["Proven to Sell: AI Model Images That Work", " (D Company’s Success)"],
      [DeviceType.MO]: ["Proven to Sell: AI Model Images That Work", " (D Company’s Success)"],
    },
    benefitTextList: [
      [
        { title: "Increase in Traffic", description: "48%" },
        { title: "Boost in Conversion Rate", description: "8%" },
        { title: "Growth in Sales Volume", description: "60%" },
      ],
    ],
    graphLabel1: "Before Potoo: Studio Model Shots",
    graphLabel2: "After Potoo: AI-Generated Model Images",
    graphData1: "Traffic",
    graphData2: "Conversion Rate",
    graphData3: "Sales Volume",
    buttonText: "Start for Free Now",
  },
  featureSection1: {
    tabTextList: ["50+ background options", "Exclusive AI models", "Back-view model images"],
    headlines: {
      [DeviceType.PC]: ["No More Shoots or Model Hires - Potoo Does It All."],
      [DeviceType.MO]: ["No More Shoots or Model Hires - Potoo Does It All."],
    },
    subtitles: {
      [DeviceType.PC]: [
        "Sell more with AI-generated model images, no need for models or a studio.",
      ],
      [DeviceType.MO]: [
        "Sell more with AI-generated model images, no need for models or a studio.",
      ],
    },
  },
  featureSection2: {
    headlines: {
      [DeviceType.PC]: ["One Product Photo, Stunning Model Images"],
      [DeviceType.MO]: ["One Product Photo, Stunning Model Images"],
    },
    contentsTitle: "Generate Wear-cuts",
    subtitles: [
      "Product Images aren’t enough to appeal to customers.",
      "<br/>",
      '<span className="violet-500">Boost your conversion rate by over x2</span> using Potoo!',
    ],
    creditInfo: "1 credit = $1",
  },
  featureSection3: {
    headlines: {
      [DeviceType.PC]: ["All the Contents You Need", "<br/>", "for Fashion E-commerce"],
      [DeviceType.MO]: ["All the Contents", "<br/>", "You Need for", "<br/>", "Fashion E-commerce"],
    },
    contentsTitle: "All-in-one contents solution",
    label: "Upcoming Release",
    subtitles: {
      [DeviceType.PC]: [
        "Automatically generate all the contents needed",
        "<br/>",
        'for <span className="green-600">sales to promotions</span> - product pages',
        "<br/>",
        "product descriptions, shortform contents.",
      ],
      [DeviceType.MO]: [
        'Automatically generate all the contents needed for <span className="green-600">sales to promotions</span> - product pages, product descriptions, shortform contents.',
      ],
    },
  },
  ctaSection: {
    title: "The Easiest Fashion AI Solution",
    subtitle: "Experience the innovation of Potoo",
    signUpButtonText: "Sign Up for Free",
  },
  rollingBannerSection: {
    title: "Trusted by 840+ fashion brands",
    contactUsButton: "Start for Free Now",
  },
  faqSection: {
    title: "FAQ",
  },
  customerSection: {
    headline: {
      title: "Customer Stories",
      subtitle: {
        [DeviceType.PC]: "Hear from our clients how we've driven real growth in their businesses.",
        [DeviceType.MO]: "Hear from our clients how we've driven real growth in their businesses.",
      },
    },
    cta: {
      title: "Ready to see what Potoo’s AI can do for your business?",
      buttonText: "Learn More",
    },
  },
  customerStorySection: {
    cta: {
      title: <>See the potential of Potoo’s AI for your team.</>,
      buttonText: "Request More Info",
    },
    bottomButton: {
      likedButtonText: "Like",
      shareToastText: "Link copied. Ready to share!",
    },
    relatedStory: {
      title: "You Might Also Like",
    },
  },
  creditSection: {
    title: "High-Quality Model Images at a Reasonable Price",
    subtitle: "Recharge credits as needed and create model images effortlessly.",
    contactUsButton: "Contact Us",
    freeTrialButton: "Start with Free Credits",
    faqTitle: "FAQ",
    ctaTitle: "Sign Up now and try Potoo AI for free!",
    ctaSubtitle: "",
    ctaButton: "Start Free Trial Now",
    creditGuideTitle: "1 credit = 1 $",
  },
  creditPriceGuide: { 
    singleOutfit: "Single Product",
    multipleOutfit: "Outfit Set Product",
    modelCut: "10 Model Images",
    credits: "Credits",
    subTextSingleOutfit: ": Single Product",
    subTextMultipleOutfit: ": Outfit Set Product",
  },
  creditRecharge: {
    title: "Credit Recharge",
    description: "Quickly and easily recharge your credits.",
    creditInfo: {
      pricePerCredit: "1 Credit = $1",
      productCredit: {
        text: `1 Product : Unlimited model images generation = ${CREDIT_PER_SKU} Credits`,
        coloredText: "Unlimited model images generation",
      },
      watermarkInfo: "Remove the watermark permanently with a one-time purchase.",
      //colorCredit: "Each additional color = 8 Credits",
    },
    creditCard: {
      modelCutProduct: "Model images creation for",
      unit: "product", // TODO : 단수 복수 구분해야함
      //singleColor: "(Single color)",
      creditText: "Credits",
      currency: "$",
      recommendedCredit: "Suggested Credits",
      bonus: "Bonus",
      enterprise: {
        title: "Enterprise",
        description: "Tailored for enterprise clients",
        cost: "Contact for Pricing",
      },
    },
    creditGuide: {
      title: "Credit Usage Guide",
      freeCredit: {
        title: "Initial Free Credit",
        description: "You can enjoy free credits only once when signing up.",
      },
      validity: {
        title: "Credit Validity Period",
        description:
          "All purchased credits (both paid and bonus) can be used within 24 months from the purchase date.",
      },
      expirationNotice: {
        title: "Expiration Notice Before Credit Expiry",
        description:
          "We will notify you via email, text messages, or other means 30 days and 7 days before the credit expiration date.",
      },
      refundPolicy: {
        title: "Credit Refund Policy",
        refundable:
          "Purchased credits are refundable at any time, with the amount corresponding to unused paid credits being refunded.",
        within7Days:
          "If no credits have been used within 7 days of purchase, a full refund will be issued upon request.",
        after7Days:
          "If more than 7 days have passed since the purchase, the refund will exclude the amount for used credits and a 10% refund fee.",
        refundMethod: "Refunds will be returned to your original payment method.",
      },
      deductionOrder: {
        title: "Credit Deduction Order",
        description:
          "Paid credits are always used first, followed by bonus credits, in order of their expiration date.",
        example: {
          title: "Example",
          paid1: "Validity: January 30, 2026",
          bonus1: "Validity: January 30, 2026",
          paid2: "Validity: March 30, 2026",
          bonus2: "Validity: March 30, 2026",
          order: "Expiration Order: 1 → 2 → 3 → 4",
        },
      },
      priceChange: {
        title: "Notice of Credit Price Changes",
        description: "Credit prices may change and will be communicated in advance.",
      },
      bonusRefund: {
        title: "Bonus Credit Refund Exclusion",
        description: "Bonus credits are not eligible for refunds.",
      },
    },
    askCount: "Enter the number of products to create.",
    rechargeButton: "Recharge",
    enterpriseButton: "Contact sales",
  },
  Banner: {
    pcTitle:
      "🎉 Join now & <span style='font-weight: 700'>Get 30 free credits</span> – Start creating! 🎉",
    mobileTitle: "🎉 Join & <span style='font-weight: 700'>Get 30 free credits!</span> 🎉",
    radioLabel: "Hide for 7 days",
  },
};
